import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const JerseyFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_15220'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_15220)'>
				<rect
					width='1.87928'
					height='35.0078'
					transform='matrix(0.581352 -0.813652 0.824541 0.565803 -4.50781 -1.80798)'
					fill='#E3243B'
				/>
				<rect
					width='1.87928'
					height='35.0078'
					transform='matrix(-0.581352 -0.813652 -0.824541 0.565803 25.4492 -1.80798)'
					fill='#E3243B'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.2434 1.86668H9.70891L9.77127 1.83084L9.06641 1.43196L9.97772 1.53168L9.84959 0.93335L10.4761 1.43196L11.1027 0.93335L10.9746 1.53168L11.8859 1.43196L11.181 1.83084L11.2434 1.86668Z'
					fill='#FAEF32'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.04688 3.6167C9.04688 3.48338 9.04688 3.34215 9.04688 3.20005C9.04688 2.46367 9.64383 1.8667 10.3802 1.8667H10.5707C11.3071 1.8667 11.904 2.46367 11.904 3.20005C11.904 3.34215 11.904 3.48338 11.904 3.6167C11.904 4.8667 10.4754 5.3667 10.4754 5.3667C10.4754 5.3667 9.04688 4.8667 9.04688 3.6167Z'
					fill='#E3243B'
				/>
				<mask
					id='mask1_2332_15220'
					style={{ maskType: 'luminance' }}
					maskUnits='userSpaceOnUse'
					x='9'
					y='1'
					width='3'
					height='5'>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M9.04688 3.6167C9.04688 3.48338 9.04688 3.34215 9.04688 3.20005C9.04688 2.46367 9.64383 1.8667 10.3802 1.8667H10.5707C11.3071 1.8667 11.904 2.46367 11.904 3.20005C11.904 3.34215 11.904 3.48338 11.904 3.6167C11.904 4.8667 10.4754 5.3667 10.4754 5.3667C10.4754 5.3667 9.04688 4.8667 9.04688 3.6167Z'
						fill='white'
					/>
				</mask>
				<g mask='url(#mask1_2332_15220)'>
					<rect
						x='10.2383'
						y='4.66663'
						width='0.476191'
						height='0.466667'
						rx='0.233333'
						fill='#FAEF32'
					/>
					<rect
						x='9.52344'
						y='3.7334'
						width='1.90476'
						height='0.466667'
						rx='0.233333'
						fill='#FAEF32'
					/>
					<rect
						x='9.52344'
						y='2.80005'
						width='1.90476'
						height='0.466667'
						rx='0.233333'
						fill='#FAEF32'
					/>
				</g>
			</g>
		</svg>
	);
};

export default JerseyFlagIcon;
